import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { style: {"background":"#242526"} }
const _hoisted_2 = {
  class: "content-title",
  style: {"display":"inline-flex","align-items":"center"}
}
const _hoisted_3 = {
  key: 0,
  style: {"display":"inline-flex","align-items":"center"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Shipment Mapping ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Payment Mapping ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Attribute Mapping ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Crons ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Mass Sync ")
const _hoisted_9 = {
  class: "app-navbar",
  style: {"background":"#242526"}
}
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "Sign Out", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "el-icon-caret-right" }, null, -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "el-dropdown-link" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y",
    alt: "avatar",
    width: "30",
    class: "avatar"
  })
], -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Sign Out ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$router.currentRoute.value.meta.title) + " ", 1),
      (_ctx.$router.currentRoute.value.meta.title != null)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            (_ctx.$router.currentRoute.value.meta.title === 'Orders')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/shipment-mapping'))),
                  size: "small",
                  type: "primary",
                  style: {"margin-left":"1rem"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.$router.currentRoute.value.meta.title === 'Orders')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/payment-mapping'))),
                  size: "small",
                  type: "primary",
                  style: {"margin-left":"1rem"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.$router.currentRoute.value.meta.title === 'Products')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 2,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/attribute-mapping'))),
                  size: "small",
                  type: "primary",
                  style: {"margin-left":"1rem"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (
            _ctx.$router.currentRoute.value.meta.title === 'Products' ||
            _ctx.$router.currentRoute.value.meta.title === 'Orders'
          )
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 3,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/crons'))),
                  size: "small",
                  type: "primary",
                  style: {"margin-left":"1rem"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.$router.currentRoute.value.meta.title === 'Products')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 4,
                  onClick: _ctx.handleMassSync,
                  size: "small",
                  type: "primary",
                  style: {"margin-left":"1rem"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_9, [
      (_ctx.isSuperAdmin)
        ? (_openBlock(), _createBlock("a", {
            key: 0,
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleSignOut && _ctx.handleSignOut(...args))),
            class: "sign-out"
          }, [
            _hoisted_10,
            _hoisted_11
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_12, [
            (
            !_ctx.$store.state.auth.dataLogin.type ||
            !_ctx.$store.state.auth.dataLogin.type === 1
          )
              ? (_openBlock(), _createBlock(_component_el_dropdown, {
                  key: 0,
                  size: "large",
                  trigger: "click",
                  style: {"align-items":"center","display":"flex","margin-top":"16px","flex-direction":"row-reverse"}
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, {
                      onClick: _ctx.handleSignOut,
                      style: {"padding":"12px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode("span", _hoisted_13, [
                      _createTextVNode(_toDisplayString(_ctx.nameAccountSelected), 1),
                      _hoisted_14
                    ]),
                    _hoisted_15
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}